module.exports = __webpack_public_path__ + "media/images/emblems/Stocken-Hoefen-coat_of_arms-a227896686940fcf03b6349d3ab091f2.svg";